const cached_trees = {}

const findItemInFilters = (entityUID, items, tree) => {
	let i = 0
	const len = items.length
	while (i < len) {
		if (items[i].entityUID === entityUID) {
			return tree
		} else if (items[i].items) {
			const returnTree = findItemInFilters(entityUID, items[i].items[0].items, [...tree, items[i].entityUID])
			if (returnTree) {
				return returnTree
			}
		}
		i += 1
	}
	return null
}

const getFilterParentTree = (entityUID, categories) => {
	if (cached_trees[entityUID]) {
		return cached_trees[entityUID]
	}
	let parentTree
	let i = 0
	const len = categories.length
	while (i < len) {
		parentTree = findItemInFilters(entityUID, categories[i].items, [])
		if (parentTree) {
			break
		}

		i += 1
	}

	if (parentTree) cached_trees[entityUID] = parentTree
	return parentTree || []
}

export default getFilterParentTree
